"use strict";var _interopRequireDefault=require("@babel/runtime/helpers/interopRequireDefault");var _styledComponents=_interopRequireDefault(require("styled-components"));Object.defineProperty(exports,"__esModule",{value:!0}),exports.ReceiptsContainer=exports.ReceiptWrapper=exports.ReceiptByTransactionIdContainer=exports.OldReceiptsButtonContainer=exports.NotFoundWrapper=exports.MainWrapper=exports.ImageContainer=exports.ErroMsgContainer=exports.DigitalLoaderContainer=void 0;const ReceiptsContainer=exports.ReceiptsContainer=_styledComponents.default.div`
    padding: 0px !important;
    margin: 2rem 0 0 0;
    display: flex;
    justify-content: center;
`,MainWrapper=exports.MainWrapper=_styledComponents.default.div`
    width: 375px;
`,NotFoundWrapper=exports.NotFoundWrapper=_styledComponents.default.div`
    text-align: center;
    padding: 2rem;
    
    .notFound {
        font-size: 22px;
        font-weight: 600;
    }
`,DigitalLoaderContainer=exports.DigitalLoaderContainer=_styledComponents.default.div`
    text-align: center;
`,ErroMsgContainer=exports.ErroMsgContainer=_styledComponents.default.div`
    text-align: center;
    padding: 2rem;
    
    .not-found {
        font-size: 22px;
        font-weight: 600;
    }
`,ReceiptByTransactionIdContainer=exports.ReceiptByTransactionIdContainer=_styledComponents.default.div`
    padding: 0px !important;
    margin: 2rem 0 0 0;
    display: flex;
    justify-content: left;
`,ReceiptWrapper=exports.ReceiptWrapper=_styledComponents.default.div`
    width: 375px;
`,ImageContainer=exports.ImageContainer=_styledComponents.default.div`
    display: flex;
    align-self: flex-start;

    .send-email-icon {
      width: 45px;
      height: 35px;
    }

    .email-btn {
      background: none;
      border: none;
      padding: 0;
      cursor: pointer;
    }
`,OldReceiptsButtonContainer=exports.OldReceiptsButtonContainer=_styledComponents.default.div`
     text-align: center;
    .receipts-btn {
        font-weight: 400;
        background: none;
        white-space: nowrap;
        cursor: pointer;
        border: 1px solid transparent;
        padding: 6px 12px;
        font-size: 16px;
        line-height: 1.42857143;
        border-radius: 4px;
        margin: 5px 10px 5px 0px;
        color: #7B1A27;
    }
`;